module.exports = __webpack_public_path__ + "img/wave.6d252a00.png";